// Generated by purs version 0.15.0
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_PackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic_Menu_V2_Types_Parametric_Parametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Average = /* #__PURE__ */ (function () {
    function Average() {

    };
    Average.value = new Average();
    return Average;
})();
var MostExpensive = /* #__PURE__ */ (function () {
    function MostExpensive() {

    };
    MostExpensive.value = new MostExpensive();
    return MostExpensive;
})();
var ProductCategory = function (x) {
    return x;
};
var newtypeProductCategory_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldProductCategory = function (dictHasField) {
    return dictHasField;
};
var eqDivisiblePricePolicy = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Average && y instanceof Average) {
                return true;
            };
            if (x instanceof MostExpensive && y instanceof MostExpensive) {
                return true;
            };
            return false;
        };
    }
};
var eqProductCategory = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.categoryModifiers)(y.categoryModifiers) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.defaultCrossSellingList)(y.defaultCrossSellingList) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.defaultPriceParameters)(y.defaultPriceParameters) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Eq.eqInt))(x.divisible)(y.divisible) && Data_Eq.eq(eqDivisiblePricePolicy)(x.divisiblePricePolicy)(y.divisiblePricePolicy) && x.name === y.name && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_PackagingContainer.eqPackagingContainersConf))(x.packagingContainersConfig)(y.packagingContainersConfig) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.vatRate)(y.vatRate);
        };
    }
};
var ordDivisiblePricePolicy = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Average && y instanceof Average) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Average) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Average) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MostExpensive && y instanceof MostExpensive) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ProductCategory (line 67, column 1 - line 67, column 41): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqDivisiblePricePolicy;
    }
};
var genericProductCategory = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericDivisiblePricePolicy = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Average.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return MostExpensive.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ProductCategory (line 53, column 1 - line 53, column 95): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Average) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof MostExpensive) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ProductCategory (line 53, column 1 - line 53, column 95): " + [ x.constructor.name ]);
    }
};
var showDivisiblePricePolicy = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Average";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    })))
};
var showProductCategory = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductCategory)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "categoryModifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "defaultCrossSellingList";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "divisiblePricePolicy";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_PackagingContainer.showPackagingContainersConfig)))(Data_Show.showString))(showDivisiblePricePolicy))(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Show.showInt)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))))({
        reflectSymbol: function () {
            return "ProductCategory";
        }
    }))
};
var unscrambleDecodeDivisiblePricePolicy = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericDivisiblePricePolicy)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Average";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    })))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodeProductCategory = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductCategory)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "categoryModifiers";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "defaultCrossSellingList";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Unscramble.decodeInt1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "divisiblePricePolicy";
        }
    })(unscrambleDecodeDivisiblePricePolicy)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_PackagingContainer.unscrambleDecodePackagingContainersConfig))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))))))))))))(Unscramble_Generic.defaultOptions)
};
var boundedDivisiblePricePoli = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordDivisiblePricePolicy;
    }
};
var enumDivisiblePricePolicy = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordDivisiblePricePolicy;
    }
};
var boundedEnumDivisiblePrice = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericDivisiblePricePolicy)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))),
    Bounded0: function () {
        return boundedDivisiblePricePoli;
    },
    Enum1: function () {
        return enumDivisiblePricePolicy;
    }
};
var encodeDivisiblePricePolicy = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericDivisiblePricePolicy)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Average";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    })))
};
var encodeProductCategory = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductCategory)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductCategory";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_PackagingContainer.encodePackagingContainersConfig))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "divisiblePricePolicy";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDivisiblePricePolicy)))({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Foreign_Generic_Class.intEncode)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "defaultCrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "categoryModifiers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))))))
};
var decodeDivisiblePricePolicy = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericDivisiblePricePolicy)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Average";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "MostExpensive";
        }
    })))
};
var decodeProductCategory = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductCategory)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductCategory";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_PackagingContainer.decodePackagingContainersConfig)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "divisiblePricePolicy";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDivisiblePricePolicy))())({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Foreign_Generic_Class.intDecode)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))))())({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "defaultCrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "categoryModifiers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ProductCategory,
    Average,
    MostExpensive,
    genericProductCategory,
    eqProductCategory,
    showProductCategory,
    encodeProductCategory,
    decodeProductCategory,
    unscrambleDecodeProductCategory,
    hasFieldProductCategory,
    newtypeProductCategory_,
    genericDivisiblePricePolicy,
    eqDivisiblePricePolicy,
    showDivisiblePricePolicy,
    encodeDivisiblePricePolicy,
    decodeDivisiblePricePolicy,
    unscrambleDecodeDivisiblePricePolicy,
    ordDivisiblePricePolicy,
    enumDivisiblePricePolicy,
    boundedDivisiblePricePoli,
    boundedEnumDivisiblePrice
};
//# sourceMappingURL=index.js.map
